import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=db70c5c2&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db70c5c2')) {
      api.createRecord('db70c5c2', component.options)
    } else {
      api.reload('db70c5c2', component.options)
    }
    module.hot.accept("./breadcrumbs.vue?vue&type=template&id=db70c5c2&", function () {
      api.rerender('db70c5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue"
export default component.exports